const ACTION_PREPEND = 'purchase/documentVerifications';

export const REFRESH_PLAID_BALANCE = `${ACTION_PREPEND}/REFRESH_PLAID_BALANCE`;
export const LINK_PLAID = `${ACTION_PREPEND}/LINK_PLAID`;
export const SAVE_PLAID_SUBSCRIPTION = `${ACTION_PREPEND}/SAVE_PLAID_SUBSCRIPTION`;
